import React, { useEffect, useState } from 'react';
import { useCrmOrgs } from '../../../environments/useCrmOrgs';
import DeployProgress from './DeployProgress';
import { useRunOnce } from '../../../../common/useRunOnce';
import DeployContent from './DeployContent';
import { useDeployFunnel } from './useDeployFunnel';

interface DeployDialogProps {
  open: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  initialCrmOrgId: string;
  funnels?: Funnel[];
  funnelMapId: string;
  initialFunnelId?: string;
  initialStep?: 'step1' | 'step2' | 'step3';
}

const DeployDialog = ({
  open: envDialogOpen,
  setIsOpen: setEnvDialogOpen,
  initialCrmOrgId,
  funnels,
  funnelMapId,
  initialFunnelId,
  initialStep,
}: DeployDialogProps) => {
  const { getConnectedCrmOrgs } = useCrmOrgs();

  const [selectedFunnelId, setSelectedFunnelId] = useState(
    initialFunnelId || (funnels ? funnels[0]?.id : ''),
  );
  const [note, setNote] = useState('');
  const [selectedOrgId, setSelectedOrgId] = useState(initialCrmOrgId);

  const {
    progressDialogOpen,
    setProgressDialogOpen,
    deployStatusAsync,
    deploymentMessages,
    orgs,
    onConfirmDeployAsync,
    onRequestChanges,
  } = useDeployFunnel({
    selectedOrgId,
    selectedFunnelId,
    note,
    funnelMapId,
    onDialogClose: () => setEnvDialogOpen(false),
  });

  useRunOnce(() => {
    if (!orgs?.length) {
      getConnectedCrmOrgs();
    }
  });

  useEffect(() => {
    if (envDialogOpen) {
      setSelectedOrgId(initialCrmOrgId);
      if (initialFunnelId) {
        setSelectedFunnelId(initialFunnelId);
      }
    }
  }, [envDialogOpen, initialCrmOrgId, initialFunnelId]);

  return (
    <>
      {!progressDialogOpen && funnels && (
        <DeployContent
          orgs={orgs}
          funnels={funnels}
          selectedOrgId={selectedOrgId}
          setSelectedOrgId={setSelectedOrgId}
          selectedFunnelId={selectedFunnelId}
          setSelectedFunnelId={setSelectedFunnelId}
          onConfirmDeploy={onConfirmDeployAsync}
          onRequestChanges={onRequestChanges}
          onNoteChange={setNote}
          onCancel={() => setEnvDialogOpen(false)}
          initialCrmOrgId={initialCrmOrgId}
          initialStep={initialStep}
        />
      )}

      {progressDialogOpen && (
        <DeployProgress
          orgs={orgs}
          deployStatus={deployStatusAsync}
          selectedOrgId={selectedOrgId}
          deployMessages={deploymentMessages}
          setIsOpen={() => {
            setProgressDialogOpen((prev) => !prev);
            setEnvDialogOpen(false);
          }}
        />
      )}
    </>
  );
};

export default DeployDialog;
